import { StrictMode } from 'react'
import './index.css'
import './pastelDreams.css'
import ReactDOM from "react-dom/client";
import AppRentCalculator from '@/pageComponentWidget/AppRentCalculator'
import AppRentalPropertyCalculator from '@/pageComponentWidget/AppRentalPropertyCalculator'
import AppMortgagePayoffCalculator from '@/pageComponentWidget/AppMortgagePayoffCalculator'
import AppRefinanceCalculator from '@/pageComponentWidget/AppRefinanceCalculator'
import AppMortgageCalculator from '@/pageComponentWidget/AppMortgageCalculator'
import AppMortgageCalculatorJson from '@/pageComponentWidget/AppMortgageCalculatorJson'
import AppGeneralAPRCalculator from '@/pageComponentWidget/AppGeneralAPRCalculator'
import AppMonthBudgetBasedHouseAffordability from '@/pageComponentWidget/AppMonthBudgetBasedHouseAffordability'
import AppHouseAffordabilityCalculator from '@/pageComponentWidget/AppHouseAffordabilityCalculator'
import AppDebtToIncomeCalculator from '@/pageComponentWidget/AppDebtToIncomeCalculator'
import AppAmortizedLoanCalculator from '@/pageComponentWidget/AppAmortizedLoanCalculator'

function mountComponent(id: string, Component: React.FC) {
    const el = document.getElementById(id);
    if (el) {
        ReactDOM.createRoot(el).render(
            <StrictMode>
                <Component />
            </StrictMode>
        );
    }
}

mountComponent('AppRentCalculator', AppRentCalculator);
mountComponent('AppRentalPropertyCalculator', AppRentalPropertyCalculator);
mountComponent('AppMortgagePayoffCalculator', AppMortgagePayoffCalculator);
mountComponent('AppRefinanceCalculator', AppRefinanceCalculator);
mountComponent('AppMortgageCalculator', AppMortgageCalculator);
mountComponent('AppMortgageCalculatorJson', AppMortgageCalculatorJson);
mountComponent('AppGeneralAPRCalculator', AppGeneralAPRCalculator);
mountComponent('AppMonthBudgetBasedHouseAffordability', AppMonthBudgetBasedHouseAffordability);
mountComponent('AppHouseAffordabilityCalculator', AppHouseAffordabilityCalculator);
mountComponent('AppDebtToIncomeCalculator', AppDebtToIncomeCalculator);
mountComponent('AppAmortizedLoanCalculator', AppAmortizedLoanCalculator);